export default "__VITE_ASSET__iu5YBbmO__"